import React from 'react'

import Button from 'app/app/(client)/components/atoms/Button/Button'
import Spinner from 'app/app/(client)/components/atoms/Spinner/Spinner'

type ButtonwithSpinnerProps = React.ComponentProps<typeof Button> & {
  loading?: boolean
  spinnerSize?: number
  spinnerType?: 'primary' | 'danger'
  spinnerClassName?: string
  spinnerSpeed?: number
}

const ButtonwithSpinner: React.FC<ButtonwithSpinnerProps> = ({
  id,
  children,
  className,
  size = 'medium',
  variant = 'primary',
  type = 'button',
  loading = false,
  spinnerSize = 20,
  spinnerType = 'primary',
  spinnerClassName = '',
  spinnerSpeed = 1,
  ...props
}) => (
  <Button
    id={id}
    disabled={loading || props.disabled}
    className={`${className} ${loading ? `btn--loading-${variant}` : ''}`}
    size={size}
    type={type}
    variant={variant}
    {...props}
  >
    {loading ? (
      <div className="flex items-center justify-center gap-2">
        <Spinner size={spinnerSize} type={spinnerType} className={spinnerClassName} speed={spinnerSpeed} />
      </div>
    ) : (
      children
    )}
  </Button>
)

export default ButtonwithSpinner
